const NotifyMeActions = {
    SHOW_ACTION: 'SHOW_ACTION',
    HIDE_ACTION: 'HIDE_ACTION',
    SET_NAME_ACTION: 'SET_NAME_ACTION',
    SET_MARKETING_CONSENT_ACTION: 'SET_MARKETING_CONSENT_ACTION',
    SET_EMAIL_ACTION: 'SET_EMAIL_ACTION',
    SET_PHONE_ACTION: 'SET_PHONE_ACTION',
    SET_SKU_ACTION: 'SET_SKU_ACTION',
    EMAIL_INVALID_ACTION: 'EMAIL_INVALID_ACTION',
    EMAIL_VALID_ACTION: 'EMAIL_VALID_ACTION',
    PHONE_INVALID_ACTION: 'PHONE_INVALID_ACTION',
    PHONE_VALID_ACTION: 'PHONE_VALID_ACTION',
    SET_TYPE_ACTION: 'SET_TYPE_ACTION',
    SET_QUANTITY_ACTION: 'SET_QUANTITY_ACTION',
    FORM_SUBMIT: 'FORM_SUBMIT'
};

export { NotifyMeActions };